import request from '@/utils/request'

// 待办服务列表
export const getTodoServiceList = () => request({
  url: '/workOnLine/employ/getTodoEmployList',
  method: 'get'
})
// 已办服务列表
export const getDoneServiceList = () => request({
  url: '/workOnLine/employ/getFinishedEmployList',
  method: 'get'
})
// 申请记录服务列表
export const getApplyServiceList = () => request({
  url: '/workOnLine/employ/getUserEmployList',
  method: 'get'
})
// 抄送服务列表
export const getCopyforServiceList = () => request({
  url: '/workOnLine/employ/getUserCopyEmployList',
  method: 'get'
})
// 待办申请列表
export const getTodoApplyList = (data) => request({
  url: '/workOnLine/employ/getTodoApplyList',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 已办申请列表
export const getDoneApplyList = (data) => request({
  url: '/workOnLine/employ/getFinishedApplyList',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 申请记录列表
export const getApplyList = (data) => request({
  url: '/workOnLine/employ/getUserApplyList',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 抄送列表
export const getCopyforApplyList = (data) => request({
  url: '/workOnLine/employ/getMyCopyList',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 审批详情
export const getCheckedDetail = (applyId) => request({
  url: '/workOnLine/employ/getEmployApplyInfo',
  method: 'get',
  params: { applyId }
})
// 同意申请
export const agreeApply = (data) => request({
  url: '/workOnLine/employ/completeEmployApply',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 拒绝申请
export const rejectApply = (data) => request({
  url: '/workOnLine/employ/rejectEmployApply',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 撤销申请
export const revokeApply = (params) => request({
  url: '/workOnLine/employ/revokeEmployApply',
  method: 'get',
  params
})